

export class GeoFenceBranchOutput implements IGeoFenceBranchOutput {
    /** The auto-generated id of the branch details master */
    branch_detail_id!: number;
    /** The branch name with 255 character */
    branch!: string;

    constructor(data?: IGeoFenceBranchOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.branch_detail_id = _data["branch_detail_id"];
            this.branch = _data["branch"];
        }
    }

    static fromJS(data: any): GeoFenceBranchOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GeoFenceBranchOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["branch_detail_id"] = this.branch_detail_id;
        data["branch"] = this.branch;
        return data; 
    }
}

export interface IGeoFenceBranchOutput {
    /** The auto-generated id of the branch details master */
    branch_detail_id: number;
    /** The branch name with 255 character */
    branch: string;
}

